<template>
    <div class="game_zone">
        <img class="game_icon" :src="gameIcon" alt="">
        <div class="gz_intr">
            <div class="gi_1">{{gameName}}</div>
            <div class="gi_2">
                <span>{{ Number(follows) > 10000 ? ( Number(follows) / 10000).toFixed(1) + 'w+' :  Number(follows) }}关注</span>&nbsp;
                <span>{{ Number(topicNum) > 10000 ? (Number(topicNum) / 10000).toFixed(1) + 'w+' : Number(topicNum) }}帖子</span>
            </div>
        </div>
    </div>  
</template>
<script>
export default {
    name: 'game-zone',
    props: {
        gameIcon: String,
        gameName: String,
        gameId: String,
        follows: [String,Number],
        topicNum: [String,Number],
    },
    data() {
        return {
            
        }
    },
    methods: {
        gotoGame() {
            this.$parent.$parent.$parent.$parent.openGame(this.gameId)
        }
    },
}
</script>
<style lang="less" scoped>
    .game_zone {
        background-color: #e4e4e4;
        display: flex;
        align-items: center;
        padding: 0.5rem .6rem;
        border-radius: 0.5rem;
        height: 5.45rem;
        cursor: pointer;
        .game_icon {
            width: 4.5rem;
            height: 4.5rem;
            border-radius: 0.3rem;
            margin-right: 0.8rem;
        }
        .gz_intr {
            .gi_1 {
                font-size: 1rem;
                font-weight: 700;
                color: #000;
                margin-bottom: .75rem;
            }
            .gi_2 {
                font-size: 0.7rem;
                color: #5a5a5a;
            }
        }
    }
</style>
